import { StandardEvents } from '@shopify/events';
const count = document.querySelector('[data-md-cart-count]');
if (count) {
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({ cart, detail }) => {
      const quantity = cart?.totalQuantity ?? detail?.itemCount;
      if (typeof quantity === 'number') count.textContent = String(quantity);
    }).catch(() => {});
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json()).then((cart) => { count.textContent = String(cart.item_count); }).catch(() => {});
  });
}
